import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import './ReactCarousel.scss';

const ReactCarousel = props => (
  <Slider {...props.settings}>
    {props.children}
  </Slider>
);

ReactCarousel.propTypes = {
  children: PropTypes.node,
  settings: PropTypes.object,
};

export default ReactCarousel;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ReactCarousel/ReactCarousel.js